// eslint-disable-next-line simple-import-sort/imports
import { getLang, getLangCode } from 'src/util/lang';
import Vue from 'vue';
import maxLength from 'vue_input_maxlength';
import VuePortal from '@linusborg/vue-simple-portal';

import atom from '@tencent/vft-atom';
import cookie from '@tencent/vft-common/cookie';
import env from '@tencent/vft-common/env';
import reportPlugin, { createAttaReporter } from '@tencent/vft-report';
import Dialog from '@tencent/vft-vue-plugins/src/dialog';
import login from '@tencent/wetv-common/login';
import APPID from '@tencent/wetv-common/wetvEnv/appid';
import { COUNTRY } from '@tencent/wetv-common/wetvEnv/country';

import MobileApp from 'src/container/main.vue';
import WebApp from 'src/container/web-app.vue';
import store from 'src/store';
import { checkAndApplyDarkMode } from 'src/util';

import langPlugin from './lang';
Vue.use(langPlugin);
Vue.use(Dialog);

login.init('wetvLib');
window.document.title = Vue.prototype.$lang[33];

console.log(APPID, COUNTRY);

Vue.use(maxLength);
Vue.use(reportPlugin, {
  /** 是否输出调试信息，true为不输出 */
  silent: true,
  middlewares: [
    createAttaReporter({
      delay: false,
      config: {
        // 如果已切换至atta，使用atta配置参数
        pv: { attaId: '0e400068800', token: '4638848787' },
        // 原boss则使用boss配置参数(即将废弃)
        event: { attaId: '0e400068800', token: '4638848787' },
      },
      observerOptions: {
        root: document.body,
      },
      async extraParams() {
        const vuserid = cookie.get('vuserid');
        const guid = cookie.get('video_omgid');
        const params = {
          hc_pvid: cookie.get('pgv_pvid'),
          f_uid: vuserid || guid,
          f_omgid: cookie.get('video_omgid'),
          f_guid: guid,
          f_h5_version: window.H5_VERSION || '',
          f_language: getLang(),
          f_language_code: getLangCode(),
          f_country: COUNTRY.name,
          f_country_code: COUNTRY.code,
          f_appid: APPID,
          f_vuid: vuserid || '',
          qimei36: cookie.get('vdevice_qimei36') || '',
        };
        return params;
      },
    }),
  ],
});

Vue.prototype.$bus = new Vue();

Vue.use(VuePortal, {
  name: 'portal',
  defaultSelector: 'pop',
});
Vue.mixin({
  methods: {
    async toBind() {
      if (env.isApp) {
        const res = await atom.invoke('openBindPhonePannel', null);
        if (res && +res.bindState === 1) {
          this.$store.dispatch('getUserInfo');
        }
      } else {
        window.wetvLogin.show('bind');
      }
    },
  },
});

window.wetvLogin && window.wetvLogin.onBindPhone(() => {
  // 回调中返回的手机号非标准的区号 和 手机号形式，为兼容各种情况，重新从接口拉手机号信息
  store.dispatch('getUserInfo');
  window.wetvLogin.hide('bind');
});

const App = env.isWeb ? WebApp : MobileApp;

new Vue({
  el: '#app',
  render: h => h(App),
  store,
});

checkAndApplyDarkMode();
